<template>
    <div>
        <div class="modal-card is-full">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-danger has-text-centered">Register Person and Date</p>
            </header>
            <section class="modal-card-body has-background-dvodark">
            <p class="has-text-white is-size-5">This item is NOT registered. Please enter the customer's first and last name. This item also lacks a purchase date. Please prompt the owner for the date of purchase and enter the purchase date.</p>
            <b-field horizontal label="First Name">
                <div class="control">
                    <input class="input has-text-white" type="text" v-model="firstName">
                </div>
            </b-field>
            <b-field horizontal label="Last Name">
                <div class="control">
                    <input class="input has-text-white"  tyoe="text" v-model="lastName">
                </div>
            </b-field>
            <b-field horizontal label="Address">
                <div class="control">
                    <input class="input has-text-white" type ="text" v-model="address">
                </div>
            </b-field>
            <b-field horizontal label="Country">
                <div class="control">
                    <input class="input has-text-white" type="text" v-model="country">
                </div>
            </b-field>
            <b-field horizontal label="Select a date">
                <b-datepicker v-model="warrantyDate" locale="en-US" placeholder="Click to select..."
                    icon="calendar-today" trap-focus>
                </b-datepicker>
            </b-field>
            </section>
            <footer class="modal-card-foot">
                    <div class="field is-grouped">
                        <p class="control">
                            <button :disabled="!canSubmitForm" @click="signUp();" class="button is-dvogreen">
                                Save changes
                            </button>
                        </p>
                        <p class="control">
                            <button @click="$emit('onCancel'); $emit('close')" class="button is-danger">
                                Cancel
                            </button>
                        </p>
                    </div>
            </footer>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { personHandler, itemHandler } from '../graphql/mutations'
export default {
    data() {
        return {
        username: null,
        email: null,
        password: null,
        userSubHolder: null,
        firstName: null,
        lastName: null,
        address: null,
        country: null,
        warrantyDate: new Date(),
        submitEventData: null
        };
    },
    computed:{
        computedWarrantyDate: function(){
            return this.warrantyDate.toISOString().slice(0, 10)
        },
        canSubmitForm: function(){
            if(this.firstName && this.lastName) {
                return true
            } else {
                return false
            }
        }
    },
    props:['initSerial'],
    methods:{
        async signUp() {
        try {
            await API.graphql({
                query: itemHandler,
                variables: {
                input: {
                    request_type: 'update_date_purchase',
                    date_purchase: this.computedWarrantyDate,
                    serial: this.initSerial
                }}
            });

            const personHolder = await API.graphql({
                query: personHandler,
                variables: {
                input: {
                    request_type: 'create',
                    cognito_id: null,
                    first_name: this.firstName,
                    last_name: this.lastName,
                    address: this.address,
                    country: this.country,
                    email: ''
                }}
                
            });

            const personId = personHolder.data.personHandler.id
            
            let returnItemHolder = await API.graphql({
                query: itemHandler,
                variables: {
                input: {
                    request_type: 'update_person',
                    person_id: personId,
                    serial: this.initSerial
                }}
            });

            console.log(returnItemHolder)

            this.submitEventData = returnItemHolder.data.itemHandler

            console.log(this.submitEventData)

            this.$emit('onSubmit', this.submitEventData );
            this.$emit('close')
            } catch (e) {
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `${e}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
                })
            }
        }
    },
}
</script>

<style lang="scss">
    .is-full{
        min-height: 75vh;
        min-width: 50vw;
    }
</style>